import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import { BirdIcon } from 'assets/SVGIcons'
import LinkButton from 'components/atoms/buttons/LinkButton'

const styles = theme => ({
  root: {
    textAlign: 'center',
    animation: 'fadeIn 0.3s ease',
    padding: `${theme.spacing(6)}px 0`,
    backgroundColor: theme.palette.background.header,
  },
  icon: {
    width: 97,
    height: 97,
  },
  title: {
    marginTop: theme.spacing(1),
  },
  text: {
    maxWidth: 540,
    margin: '0 auto',
    marginTop: theme.spacing(1),
  },
  actionButton: {
    marginTop: theme.spacing(3),
  },
})

const OverviewPlaceholder = ({ classes, title, text }) => (
  <section className={classes.root}>
    <BirdIcon className={classes.icon} />
    <Typography className={classes.title} variant="h1">
      {title}
    </Typography>
    <Typography className={classes.text}>{text}</Typography>
    <LinkButton
      className={classes.actionButton}
      label="Invite contributors"
      to="/dashboard/people/all"
    />
  </section>
)

OverviewPlaceholder.defaultProps = {
  title: 'Oh no, there is no data to display here yet',
  text:
    'Share an invite code with Goodnature Chirp App users so they can share traps with you',
}

OverviewPlaceholder.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
  classes: PropTypes.object,
}

export default withStyles(styles)(OverviewPlaceholder)



// WEBPACK FOOTER //
// ./src/components/atoms/OverviewPlaceholder.js